import t from './actionTypes'

const shareActions = {
	fetchShareData(entityUID, entityType, libraryID) {
		return {
			type: t.FETCH_SHARE_DATA,
			entityUID,
			entityType,
			libraryID,
		}
	},
	sendShareEmailSelfPacedForm(emailTo, presentation_uid, pinToShare) {

		const service = 'service.php'
		const url = 'services'
		const queryObject = {
			emailTo,
			presentation_uid,
			pinToShare,
			method: 'sendEmailShareHomeworkPin',
		}

		return {
			type: t.SEND_FORM_POST,
			params: {
				service,
				queryObject,
				url,
			},
		}
	},
	sendShareEmailForm(emailTo, entityUID, entityType, privateLibraryId, templates) {

		let queryObject = {}
		let url = 'services'
		let service

		switch (entityType) {
			case 'lesson':
				queryObject = {
					emailTo,
					entityUID,
					privateLibraryId,
				}
				queryObject = templates.reduce((accumulator, item, index) => {
					accumulator[`emailLinks[${index}]`] = item
					return accumulator
				}, queryObject)

				service = 'presentation/shareEmail.php'
				break
			case 'storefront':
				queryObject = {
					emailTo,
				}

				service = 'storefront/' + entityUID + '/email'
				url = 'api'
				break
			case 'folder':
				queryObject = {
					emailTo,
					folderId: entityUID,
					method: 'sendEmailShareNPPFolder',
				}
				queryObject = templates.reduce((accumulator, item, index) => {
					accumulator[`emailLinks[${index}]`] = item
					return accumulator
				}, queryObject)

				service = 'service.php'
				break
			default:
				queryObject = {
					emailTo,
					entityUID,
				}

				service = 'bundle/shareEmail.php'
				break
		}

		return {
			type: t.SEND_FORM_POST,
			params: {
				service,
				queryObject,
				url,
			},
		}
	},
	shareEntity(entityType, entityUID, source, count) {
		return {
			type: t.SHARE_ENTITY,
			entityType,
			entityUID,
			source,
			count,
		}
	},
	shareEntityLink(entityType, entityUID, isEditableLink, editableLinkAvailable) {
		return {
			type: t.SHARE_ENTITY_LINK,
			entityType,
			entityUID,
			isEditableLink,
			editableLinkAvailable,
		}
	},
}

export default shareActions
